import { EffectDef } from './types';
import { eq } from './eq';
import { compressor } from './compressor';
import { delay } from './delay';
import { reverb } from './reverb';
import { distortion } from './distortion';
import { chorus } from './chorus';
import { flanger } from './flanger';
import { phaser } from './phaser';
import { widener } from './widener';
import { bitcrusher } from './bitcrusher';
import { gate } from './gate';

/** All available effects, keyed by type. */
export const EFFECTS: Record<string, EffectDef> = {};

for (const def of [
  eq,
  compressor,
  delay,
  reverb,
  distortion,
  chorus,
  flanger,
  phaser,
  widener,
  bitcrusher,
  gate,
]) {
  EFFECTS[def.type] = def;
}

export function effectTypes(): string[] {
  return Object.keys(EFFECTS);
}